let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("MJwFb"), load("6wr18"), load("kjZZD"), load("ffEVr"), load("6KGrg")]).then(() => parcelRequire('1dhEU'));